<template>
    <!-- Start -->

    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-10">
                <div class="features-absolute bg-white shadow rounded overflow-hidden card-group">
                    <div v-for="item in datas" :key="item" :class="item.class">
                        <i :class="item.icon"></i>
                        <h5 class="mt-1">{{item.name}}</h5>
                        <p v-if="item.desc2 === true" class="text-muted mt-2">{{item.desc}}</p>
                            <ul v-if="item.timing === true" class="list-unstyled mt-2">
                            <li class="d-flex justify-content-between">
                                <p class="text-muted mb-0">{{item.mon}}</p>
                                <p class="text-primary mb-0">{{item.time}}</p>
                            </li>
                            <li class="d-flex justify-content-between">
                                <p class="text-muted mb-0">{{item.satur}}</p>
                                <p class="text-primary mb-0">{{item.time2}}</p>
                            </li>
                            <li class="d-flex justify-content-between">
                                <p class="text-muted mb-0">{{item.sun}}</p>
                                <p class="text-primary mb-0">{{item.time3}}</p>
                            </li>
                        </ul>
                        <router-link to="/departments" class="text-primary">Read More <i
                                class="ri-arrow-right-line align-middle"></i></router-link>
                    </div>

                </div>
            </div><!--end col-->
        </div><!--end row-->
    </div><!--end container-->


    <!-- End -->
</template>

<script setup>
import {ref} from 'vue'

const datas = ref([
                {
                    icon: 'ri-heart-pulse-fill text-primary h2 mb-0',
                    name: 'Emergency Cases',
                    desc: "This is required when, for example, the is not yet available. Dummy text is also known as 'fill text'.",
                    class: 'card border-0 bg-light p-4',
                    desc2: true
                },
                {
                    icon: 'ri-dossier-fill text-primary h2 mb-0',
                    name: 'Doctors Timetable',
                    desc: "This is required when, for example, the is not yet available. Dummy text is also known as 'fill text'.",
                    class: 'card border-0 p-4',
                    desc2: true
                },
                {
                    icon: 'ri-time-fill text-primary h2 mb-0',
                    name: 'Opening Hours',
                    mon: 'Monday - Friday',
                    time: '8.00 - 20.00',
                    satur: 'Saturday',
                    time2: '8.00 - 18.00',
                    sun: 'Sunday',
                    time3: '8.00 - 14.00',
                    class: 'card border-0 bg-light p-4',
                    timing: true
                },
            ])

</script>

<style lang="scss" scoped></style>